export default class Viewer {
  constructor(payload) {
    this.id = payload.id ?? null;
    this.key = payload.key ?? null;
    this.name = payload.name ?? null;
    this.schedules = payload.schedules ?? [];
    this.screenshotUpdatedAt = payload.screenshotUpdatedAt ?? null;
    this.registeredAt = payload.registeredAt ?? null;
    this.canStream = payload.canStream ?? null;
    this.isStreaming = payload.isStreaming ?? null;
    this.status = {
      connectionStatus: payload?.connectionStatus ?? "OFFLINE",
      displayStatus: payload?.displayStatus ?? "OFF",
      ipAddress: payload?.ipAddress ?? null,
      contentId: payload?.contentId ?? null,
      contentName: payload?.contentName ?? null,
      scheduleId: payload?.scheduleId ?? null,
      scheduleName: payload?.scheduleName ?? null,
      version: payload?.version ?? null,
      updatedAt: payload?.statusUpdatedAt ?? null,
    };
    this.activeAt = payload.activeAt ?? null;
    this.screenGroups = payload.screenGroups ?? [];
    this.organizationId = payload.organizationId ?? null;
    this.location = payload?.metadata?.address1 ?? null;
    this.locationDesc = payload?.metadata?.address2 ?? null;
    this.externalInfo = {
      hivestackScreenId: payload?.metadata?.hivestackScreenId,
      vistarDeviceId: payload?.metadata?.vistarDeviceId,
      vistarVenueId: payload?.metadata?.vistarVenueId,
    };
    this.coordinate = {
      latitude: payload.latitude ?? null,
      longitude: payload.longitude ?? null,
    };
  }
}
